import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DialogModule } from 'primeng/dialog'
import { ButtonModule } from 'primeng/button'
import { SelectModule } from 'primeng/select'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { ShiftOriginModel } from '../../../../core/models/shift-origin.model'
import { ProgressSpinnerModule } from 'primeng/progressspinner'

@Component({
  selector: 'app-unprogramming-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    SelectModule,
    ReactiveFormsModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './unprogramming-modal.component.html',
  styleUrls: ['./unprogramming-modal.component.scss'],
})
export class UnprogrammingModalComponent implements OnInit {
  @Input() visible: boolean = false
  @Input() selectedEvent: any = null
  @Input() shiftOrigins: ShiftOriginModel[] = []
  @Input() submitting: boolean = false

  @Output() visibleChange = new EventEmitter<boolean>()
  @Output() onSubmit = new EventEmitter<any>()
  @Output() onCancel = new EventEmitter<void>()

  unprogramForm: FormGroup

  private _loadingShiftOrigins = false
  @Input()
  get loadingShiftOrigins(): boolean {
    return this._loadingShiftOrigins
  }
  set loadingShiftOrigins(value: boolean) {
    this._loadingShiftOrigins = value
    this.updateFormControlsState()
  }

  constructor(private fb: FormBuilder) {
    this.unprogramForm = this.fb.group({
      shiftOriginId: [null as number | null, Validators.required],
      reason: [''],
    })
  }

  ngOnInit(): void {}

  ngOnChanges(): void {
    // Reset the form when the dialog becomes visible
    if (this.visible) {
      this.unprogramForm.reset()
    }
  }

  hide(): void {
    this.visible = false
    this.visibleChange.emit(false)
    this.onCancel.emit()
  }

  submit(): void {
    if (this.unprogramForm.valid && !this.submitting) {
      const formData = {
        origin: this.unprogramForm.get('shiftOriginId')?.value,
        reason: this.unprogramForm.get('reason')?.value,
        erpSource: this.selectedEvent?.extendedProps?.data?.erpSource,
      }
      this.onSubmit.emit(formData)
    }
  }

  // Add this method to update when loadingShiftOrigins changes
  private updateFormControlsState(): void {
    if (this.loadingShiftOrigins) {
      this.unprogramForm.get('shiftOriginId')?.disable()
    } else {
      this.unprogramForm.get('shiftOriginId')?.enable()
    }
  }
}
